import {mapGetters} from 'vuex';
import {formatDateTime} from '@/mixins/formatDateTime';

export const calcRouletteTimer = {
    mixins: [
        formatDateTime
    ],
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters({
            sound: 'roulette/fetchSound'
        })
    },
    methods: {
        calcRouletteTimer() {
            // TODO: при получении от сервера команды к запуску рулетки учесть текущее время таймера, запуск показать после истечения времени. иначе оставляем таймер 0
            // console.log(this.nextPlay);
            if (!this.nextPlay) {
                return;
            }
            let remain = this.nextPlay - new Date();
            if (remain <= 60000) {
                this.showCountdown = true;
            }
            // if (remain > 10000) {
            //     this.timingPlayed = false;
            // }
            if (
                remain < 5000 &&
                remain > 0 &&
                this.timingPlayed === false
            ) {
                this.timingPlayed = true;
                let timingSound = document.getElementById('timing-sound');
                // if (timingSound && this.sound) {
                if (timingSound) {
                    let timingPromise = timingSound.play();
                    if (timingPromise) {
                        timingPromise.then(() => {return;}).catch(() => {return;});
                    }
                }
            }
            if (remain < 1000) {
                this.showCountdown = false;
            }
            let ms = this.getMS(Math.ceil(remain/1000)*1000);
            this.timeRemain = ms;
        }
    }
}
